import { render, staticRenderFns } from "./formulator-ingredients.vue?vue&type=template&id=055e28eb&"
import script from "./formulator-ingredients.vue?vue&type=script&lang=js&"
export * from "./formulator-ingredients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports